import ProfitOrLossWithoutPerc from "@/elements/ProfitOrLoss/ProfitOrLossWithoutPerc";
import { getProductType } from "@/lib/orders";
import { getForRegularOrderStatus } from "@/lib/placeOrder";
import { cn, putComma } from "@/lib/utils";
import { updateField } from "@/store/features/stocksDetailsSlice";
import moment from "moment";
import { SlArrowDown } from "react-icons/sl";
import { useDispatch, useSelector } from "react-redux";

function StockOtherDetails({ trade }) {
    const dispatch = useDispatch();
    const { orderDetails, isOderDetails, gttDetails, holdingDetails } = useSelector((state) => state.stocksDetails);

    const isSLM = orderDetails?.order_type == "SL" || orderDetails?.order_type == "SLM";

    if (orderDetails?.status || gttDetails?.status) {
        return (
            <div className="px-4 font-Inter">
                <hr className="my-4" />
                <div
                    className="flex justify-between cursor-pointer"
                    onClick={() => dispatch(updateField({ field: "isOderDetails", value: !isOderDetails }))}
                >
                    <div className="text-sm font-semibold text-black">Order details</div>
                    <div className="text-sm font-semibold text-black">
                        <SlArrowDown
                            size={16}
                            className={cn(isOderDetails ? "rotate-180" : "rotate-0", "transition-all")}
                        />
                    </div>
                </div>
                {orderDetails?.status && (
                    <div
                        className={`transition-all overflow-hidden ${
                            isOderDetails ? "max-h-[600px] pt-4" : "pt-0 max-h-0"
                        }`}
                    >
                        <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Validity</p>
                            <p className="font-bold">{orderDetails?.order_validity}</p>
                        </div>
                        <div className="flex justify-between items-center p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Product</p>
                            <p className="font-bold">{getProductType(orderDetails?.product)}</p>
                        </div>
                        {isSLM && (
                            <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                                <p className="font-medium text-[#414141]">Trigger price</p>
                                <p className="font-bold">{orderDetails?.trigger_price}</p>
                            </div>
                        )}
                        <div
                            style={{ backgroundColor: isSLM ? "" : "#F5F5F5" }}
                            className="flex justify-between items-center p-2 rounded-md text-black text-xs leading-5"
                        >
                            <p className="font-medium text-[#414141]">Order time</p>
                            <p className="font-bold">
                                {moment(
                                    orderDetails?.order_date_time ?? orderDetails?.created_at,
                                    "YYYY-MM-DDTHH:mm:ssZ[Z]"
                                ).format("DD-MM-YYYY | HH:mm:ss")}
                            </p>
                        </div>
                        {getForRegularOrderStatus(orderDetails?.status)?.[1] !== "ON-HOLD" && (
                            <div
                                style={{ backgroundColor: isSLM ? "#F5F5F5" : "" }}
                                className="flex justify-between items-center  p-2 rounded-md text-black text-xs leading-5"
                            >
                                <p className="font-medium text-[#414141]">Exchange time</p>
                                <p className="font-bold">
                                    {moment(orderDetails?.last_modified, "YYYY-MM-DDTHH:mm:ssZ[Z]").format(
                                        "DD-MM-YYYY | HH:mm:ss"
                                    )}
                                </p>
                            </div>
                        )}
                        <div
                            style={{
                                backgroundColor:
                                    isSLM || getForRegularOrderStatus(orderDetails?.status)?.[1] === "ON-HOLD"
                                        ? ""
                                        : "#F5F5F5"
                            }}
                            className="flex justify-between items-center p-2 rounded-md text-black text-xs leading-5"
                        >
                            <p className="font-medium text-[#414141]">Order ID</p>
                            <p className="font-bold">{orderDetails?.order_no ?? orderDetails?.order_number}</p>
                        </div>
                        {orderDetails?.exch_order_no > 0 && (
                            <div
                                style={{ backgroundColor: isSLM ? "#F5F5F5" : "" }}
                                className="flex justify-between items-center  p-2 rounded-md text-black text-xs leading-5"
                            >
                                <p className="font-medium text-[#414141]">Exchange ID</p>
                                <p className="font-bold">{orderDetails?.exch_order_no}</p>
                            </div>
                        )}
                    </div>
                )}
                {gttDetails?.status && (
                    <div
                        className={`transition-all overflow-hidden pt-4 ${isOderDetails ? "max-h-[600px]" : "max-h-0"}`}
                    >
                        <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Current holdings</p>
                            <p className="font-bold">{gttDetails?.total_quantity}</p>
                        </div>
                        <div className="flex justify-between items-center p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Created at</p>
                            <p className="font-bold">
                                {moment(gttDetails?.created_at, "YYYY-MM-DDTHH:mm:ssZ[Z]").format(
                                    "DD-MM-YYYY | HH:mm:ss"
                                )}
                            </p>
                        </div>
                        <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Expires on</p>
                            <p className="font-bold">
                                {moment(gttDetails?.created_at, "YYYY-MM-DDTHH:mm:ssZ[Z]")
                                    .add(1, "y")
                                    .format("DD-MM-YYYY | HH:mm:ss")}
                            </p>
                        </div>
                        <div className="flex justify-between items-center p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Order ID</p>
                            <p className="font-bold">{gttDetails?.order_number}</p>
                        </div>
                    </div>
                )}
                {holdingDetails?.orderId && (
                    <div
                        className={`transition-all overflow-hidden pt-4 ${isOderDetails ? "max-h-[600px]" : "max-h-0"}`}
                    >
                        <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Qty.</p>
                            <p className="font-bold">{holdingDetails?.quantity}</p>
                        </div>
                        <div className="flex justify-between items-center p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Avg. price</p>
                            <p className="font-bold">{putComma(holdingDetails?.cost_price)}</p>
                        </div>
                        {/* <div className='flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5'>
                    <p className='font-medium text-[#414141]'>Updated on</p>
                    <p className='font-bold'>{gttDetails?.validity}</p>
                </div> */}
                        <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                            <p className="font-medium text-[#414141]">Day’s P&L</p>
                            <ProfitOrLossWithoutPerc
                                nseLtpPrice={trade?.ltp}
                                nseClosePrice={holdingDetails?.closePrice}
                                quantity={holdingDetails?.quantity}
                                textClass="text-sm font-medium leading-6"
                            />
                        </div>
                    </div>
                )}
                <hr className="mt-4" />
            </div>
        );
    }
}

export default StockOtherDetails;
